import { Col, Menu, Row } from "antd";
import * as React from "react";
import { NavLink } from 'react-router-dom';
import Locale from "../locale/Locale";
import SearchInput from "../search/components/SearchInput";
import SearchResults from "../search/components/SearchResult";
import { navs } from "./navs";

export default () => {
    return (
        <>
        <Row style={{height: '100%'}} justify="end">
            <Col>
                <Menu
                    className="app-head-menu"
                    selectedKeys={['1']}
                    mode="horizontal"
                    theme="dark"
                >
                    {
                        Object.entries(navs).filter(([_, nav]) => ! Boolean(nav.hidden)).map(([path, nav]) => {
                            return (
                                <Menu.Item key={nav.key} eventKey={nav.key}>
                                    <NavLink to={path} style={({isActive}) => {
                                        return isActive ? {
                                            color: '#FFF',
                                            fontWeight: 'bold',
                                        } : {}
                                    }}>{nav.title}</NavLink>
                                </Menu.Item>
                            );
                        })
                    }
                </Menu>
            </Col>
            <Col style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                paddingRight: '1em',
            }}>
                <Locale />
            </Col>
            <Col style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
            }}>
                <SearchInput />
            </Col>
        </Row>
        <SearchResults />
        </>
    )
}
